import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import 'react-toastify/dist/ReactToastify.css';
import ReduxProvider from './providers/ReduxProvider';
import ThemeProviders from './providers/ThemeProvider';
import App from './App';
import './styles/tailwind.css';
import './index.css';

if (window.trustedTypes && !(window as any).trustedTypes.getPolicy?.('default')) {
  (window as any).trustedTypes.createPolicy('default', {
    createScriptURL: (input: string) => input,
    createHTML: (input: string) => input,  
  });
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <ReduxProvider>
    <ThemeProviders>
      <App />
    </ThemeProviders>
  </ReduxProvider>
);

reportWebVitals();
